import { render, staticRenderFns } from "./ai-dropdown.vue?vue&type=template&id=46cb05e8"
import script from "./ai-dropdown.vue?vue&type=script&lang=ts"
export * from "./ai-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./ai-dropdown.vue?vue&type=style&index=0&id=46cb05e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports